import React, { Fragment } from 'react';
import Grid from '../../../../components/Grid';
import { Subscription, ProductDescription, ProductLogo, ProductSection, SUBSCRIPTION_TYPE } from './ActivationContent';
var AppOpticsTracing = "https://cdn.solarwinds.cloud/cloud-ui/assets/appoptics-tracing-b66362670164d0e91b9c7dcc9362ef8e.svg";
var AppOpticsInfrastructure = "https://cdn.solarwinds.cloud/cloud-ui/assets/appoptics-infrastructure-855fd163d617c957bd636b4a7d435267.svg";
var AppOpticsMetrics = "https://cdn.solarwinds.cloud/cloud-ui/assets/appoptics-metrics-84cc0b5225cbc5bf74ad262942d02713.svg";
var AppOpticsLogo = "https://cdn.solarwinds.cloud/cloud-ui/assets/appoptics-logo-d2015cc7b06c3826879243eb44ae8c55.svg";
export var AppOpticsContent = function AppOpticsContent(_ref) {
  var productStatus = _ref.productStatus;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProductLogo, {
    logo: AppOpticsLogo
  }), /*#__PURE__*/React.createElement(ProductDescription, {
    title: "Infrastructure Metrics + Code Level Visibility",
    content: "AppOptics combines APM, Infrastrucute monitoring, and custom metrics into a single dashboard."
  }), /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(ProductSection, {
    image: AppOpticsTracing,
    title: "Distributed Tracing",
    content: "Automatically follow transactions across services, identify performance bottlenecks."
  }), /*#__PURE__*/React.createElement(ProductSection, {
    image: AppOpticsInfrastructure,
    title: "Infrastructure Monitoring",
    content: "Monitor on-premise monoliths to Kubernetes in the cloud. Multiple integrations and visibility into web servers, container orchestration, and databases."
  }), /*#__PURE__*/React.createElement(ProductSection, {
    image: AppOpticsMetrics,
    title: "Custom Metrics",
    content: "Flexible, multi-dimensional API, for submitting metrics from any source."
  })), /*#__PURE__*/React.createElement(Subscription, {
    productStatus: productStatus,
    type: SUBSCRIPTION_TYPE.TRIAL
  }));
};